<div class="wrapper">
  <h1 class="title">{{ 'teams.LocatePackage.AddTitle' | translate }}</h1>

  <div class="content">
    <form [formGroup]="templatesForm">
      <div class="template">
        <h4 class="template-title"> {{ 'teams.LocatePackage.AddCoverPageTitle' | translate }} </h4>
        <mee-upload-file [mediaType]="mediaType.LocatePackage" formControlName="CoverPagesUrl" buttonText="{{ 'teams.LocatePackage.AddCoverPage' | translate }}"></mee-upload-file>
      </div>

      <div class="template">
        <h4 class="template-title"> {{ 'teams.LocatePackage.AddMainPageTitle' | translate }} </h4>
        <mee-upload-file [mediaType]="mediaType.LocatePackage" formControlName="MainPageUrl" buttonText="{{ 'teams.LocatePackage.AddMainPage' | translate }}"></mee-upload-file>
      </div>

      <div class="offsets">
        <mat-form-field class="offset">
          <mat-label>{{ "teams.LocatePackage.TopOffset" | translate }}</mat-label>
          <input formControlName="Top" matInput />
          <mat-icon matSuffix>percent</mat-icon>
        </mat-form-field>

        <mat-form-field class="offset">
          <mat-label>{{ "teams.LocatePackage.BotOffset" | translate }}</mat-label>
          <input formControlName="Bottom" matInput />
          <mat-icon matSuffix>percent</mat-icon>
        </mat-form-field>

        <mat-form-field class="offset">
          <mat-label>{{ "teams.LocatePackage.SideOffset" | translate }}</mat-label>
          <input formControlName="Side" matInput />
          <mat-icon matSuffix>percent</mat-icon>
        </mat-form-field>
      </div>

      <div class="template">
        <h4 class="template-title"> {{ 'teams.LocatePackage.AddClosingPageTitle' | translate }} </h4>
        <mee-upload-file [mediaType]="mediaType.LocatePackage" formControlName="TrailingPagesUrl" buttonText="{{ 'teams.LocatePackage.AddClosingPage' | translate }}"></mee-upload-file>
      </div>
    </form>
  </div>

  <div class="controls">
    <button class="cancel-button" mat-button mat-dialog-close>
      {{ "system.cancel" | translate | uppercase }}
    </button>
    <button class="copy-button" mat-raised-button [disabled]="templatesForm.invalid" (click)="saveTemplates()">
      {{ "system.save" | translate | uppercase }}
    </button>
  </div>
</div>
